import { getI18n } from './i18nLoader';

export function __(key) {
  const i18n = getI18n();
  return i18n[key] || key;
}

export function __f(str) {
  const i18n = getI18n();

  const parts = [];
  let current = '';
  let insideBraces = false;

  for (let i = 0; i < str.length; i++) {
    const c = str[i];

    if (c === '{') insideBraces = true;
    if (c === '}') insideBraces = false;

    if (c === ' ' && !insideBraces) {
      if (current) parts.push(current);
      current = '';
    } else {
      current += c;
    }
  }
  if (current) parts.push(current);

  if (parts.length > 1) {
    return parts.map(p => __f(p)).join(' ');
  }

  str = parts[0];
  const match = str.match(/^([a-zA-Z0-9_]+)((?:_\{.*?\})*)$/);
  if (!match) return str;

  const key = match[1];
  const rawParams = match[2];
  const paramMatches = [...rawParams.matchAll(/\{(.*?)\}/g)];
  const params = paramMatches.map(m => m[1]);

  const template = i18n[key];
  if (!template) return str;

  return template.replace(/\{param(\d+)\}/g, (_, index) => params[parseInt(index) - 1] || '');
}


// WEBPACK FOOTER //
// ./src/utils/i18nUtils.js